import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";

import { User, Role } from "app/auth/models";
import { ToastrService } from "ngx-toastr";
import { map } from "rxjs/operators";
import { environment } from 'environments/environment';

@Injectable({ providedIn: "root" })
export class AuthenticationService {
	public currentUser: Observable<User>;

	private currentUserSubject: BehaviorSubject<User>;

	private url: string = environment.g2e_api;

	constructor(
		private _http: HttpClient,
		private _toastrService: ToastrService,
		private http: HttpClient
	) {
		this.currentUserSubject = new BehaviorSubject<User>(
			JSON.parse(localStorage.getItem("currentUser"))
		);
		this.currentUser = this.currentUserSubject.asObservable();
	}

	public get currentUserValue(): User {
		return this.currentUserSubject.value;
	}

	// Perfil do usuario logado (id_perfil_login), lido do payload do JWT gravado no login.
	// Retorna null se nao houver token ou o token for ilegivel.
	public get perfilLogin(): number | null {
		try {
			const token = localStorage.getItem('tokenApiG2E');
			if (!token) return null;
			const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
			const perfil = payload && payload.data ? Number(payload.data.id_perfil_login) : NaN;
			return isNaN(perfil) ? null : perfil;
		} catch (e) {
			return null;
		}
	}

	get isAdmin() {
		return (
			this.currentUser && this.currentUserSubject.value.role === Role.Admin
		);
	}

	get isClient() {
		return (
			this.currentUser && this.currentUserSubject.value.role === Role.Client
		);
	}

	login(email: string, password: string) {
		return this._http
			.post<any>(`${this.url}token`, { email, password })
			.pipe(
				map((user) => {
					// login successful if there's a jwt token in the response
					if (user) {
						localStorage.setItem("currentUser", JSON.stringify(user));

						setTimeout(() => {
							this._toastrService.success(
								"Bem vindo(a) ao Sistema Grupo 2E!",
								"" + user.nome + "!",
								{ toastClass: "toast ngx-toastr", closeButton: true }
							);
						}, 2500);

						// notify
						this.currentUserSubject.next(user);
					}

					return user;
				})
			);
	}

	token_api(email: string, password: string) {
		return this._http
			.post<any>(`${this.url}token`, { email, password })
			.pipe(
				map((token) => {
					return token;
				})
			);
	}

	auth(auth: string, email: string): Observable<any> {
		return this.http
			.post<any>(`${this.url}usuario/auth`, {
				auth: auth,
				email: email,
			})
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	passwordRecovery(email: string) {
		return this._http.post<any>(`${this.url}usuario/forgot-password`, {
			email: email,
		});
	}

	tokenValidation(token: string) {
		return this._http.post<any>(`${this.url}usuario/token-validation`, {
			token: token,
		});
	}

	insertPassword(token: string, password: string) {
		return this._http.post<any>(`${this.url}usuario/insert-password`, {
			token: token,
			password: password,
		});
	}

	logout(email: string) {
		this._http.post<any>(`${this.url}usuario/logout`, { email: email });
		localStorage.removeItem("currentUser");
		localStorage.removeItem("tokenApiG2E");
		this.currentUserSubject.next(null);
	}
}
